import { deiterateAPI } from "../utils/deiterateAPI.util";
import { window } from "../utils/window.util";

export namespace AuditRegister {

    export class Audit {
        static async Menu(tenancyId: string): Promise<any> {
            // Fetch audit menu settings
            const res = await deiterateAPI.POST(`/deiterateInternalAPI/audit/get/menu`, {
                mode: 'cors',
                companyID: tenancyId,
                body: JSON.stringify({ companyID: tenancyId })
            });
            return res.menu;
        }

        static async SaveMenu(tenancyId: string, menuData: any): Promise<any> {
            // Save audit menu settings
            const res = await deiterateAPI.POST(`/deiterateInternalAPI/audit/save/menu`, {
                mode: 'cors',
                companyID: tenancyId,
                body: JSON.stringify({ companyID: tenancyId, menu: menuData })
            });
            return res;
        }
    }

    export const AuditProxy = new Proxy(Audit, {
        get(target, prop) {
            const lowerCasedProp = String(prop).toLowerCase();
            if (lowerCasedProp === 'menu') {
                return target.Menu;
            } else if (lowerCasedProp === 'savemenu') {
                return target.SaveMenu;
            }
            return target[lowerCasedProp];
        }
    });
}
